// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable, asyncScheduler } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { buyLab } from '../../apis/lab';
import { buyLabActions } from '../actionCreators/buyLabActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: buyLabActions.success,
  failure: buyLabActions.failure
};

type RequestActionTypes = ActionType<
  typeof buyLabActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const buyLabEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(buyLabActions.request)
    ),
    throttleTime(1000, asyncScheduler, { leading: true, trailing: false }),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, test, creditMethod, workshopId, courseId, iltCourseId, success, onError } = action.payload;
      // send api promise
      return buyLab(id, test, creditMethod, workshopId, courseId, iltCourseId)
        .then((response: any) => {
          // handle success case here
          success && success();
          return buyLabActions.success('');
        })
        .catch((error: AxiosError) => {
          const message = error.response?.data || 'Unhandled Error';
          onError && onError(message);
          return outputActions.failure({ error: message });
        })
    })
  );
};
